import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'antd/dist/reset.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import RouteMap from './Routes/RouteMap';
import NavigationHistoryTracker from './Routes/NavigationHistoryTracker';
import DocumentTitle from './Routes/DocumentTitle';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <NavigationHistoryTracker />
          <DocumentTitle />
          <Routes>
            {RouteMap.map((route) => <Route key={route.path} {...route} />)}
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals(console.log);
